export default __webpack_public_path__ + "images/prework-w.png";